import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountBilling as GetAccountBillingQuery,
    GetAccountBilling_accountBilling as AccountBilling,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_BILLING from '../queries/get-account-billing.graphql';

export const useGetAccountBilling = (
    shouldSkip?: boolean
): {
    isLoading: boolean;
    accountBilling: AccountBilling | null | undefined;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetAccountBillingQuery, Record<any, any>>(GET_ACCOUNT_BILLING, {
        fetchPolicy: 'cache-and-network',
        skip: shouldSkip,
    });

    const accountBilling = data ? data.accountBilling : null;

    return {
        isLoading,
        accountBilling,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
